<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1">{{ tajukKad }}</p>
        </div>
        <el-form key="userData1" class="profileForm" :model="registerForm" :rules="individualRules" ref="userData1" style="width:100%;" v-loading="loading" v-if="registerForm.registrationType === 'individual'">
          <el-form-item label="Kategori Permohonan" required>
            <el-input
              ref="registrationType"
              class="el-input-size"
              :value="registrationTypeLabel"
              @input="()=>autoCapitalise('registrationType')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Nama Pemohon" required>
            <el-input
              ref="individualName"
              class="el-input-size"
              v-model="registerForm.individualName"
              @input="()=>autoCapitalise('individualName')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item required>
            <template slot="label">
              No. Kad Pengenalan
              <el-tooltip content="Sila isi no kad pengenalan tanpa '-' dengan 12 digit" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="individualIC"
              class="el-input-size"
              v-model="registerForm.individualIC"
              @input="()=>autoIC('individualIC')"
              disabled>
            </el-input>
          </el-form-item>
          <div class="card">
            <div class="cardContent">
              <el-form-item label="Alamat Operasi" prop="mainAddress1" style="gap: 5px;" required>
                <el-input
                  ref="mainAddress1"
                  class="el-input-size"
                  style="margin-bottom: 5px;"
                  v-model="registerForm.mainAddress1"
                  @input="()=>autoCapitalise('mainAddress1')"
                  :disabled="locked">
                </el-input>
                <el-input
                  ref="mainAddress2"
                  class="el-input-size"
                  v-model="registerForm.mainAddress2"
                  @input="()=>autoCapitalise('mainAddress2')"
                  :disabled="locked">
                </el-input>
              </el-form-item>
              <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" prop="mainTown" required>
                  <el-input
                    ref="mainTown"
                    class="el-input-size"
                    v-model="registerForm.mainTown"
                    @input="()=>autoCapitalise('mainTown')"
                    :disabled="locked">
                  </el-input>
                </el-form-item>
                <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" prop="mainPostcode" required>
                  <el-input
                    ref="mainPostcode"
                    class="el-input-size"
                    v-model="registerForm.mainPostcode"
                    @input="()=>autoPostcode('mainPostcode')"
                    :disabled="locked">
                  </el-input>
                </el-form-item>
              </div>
              <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" prop="mainStateLabel" required>
                  <el-select
                    ref="mainStateLabel"
                    class="el-input-size"
                    v-model="registerForm.mainStateLabel"
                    @change="()=>{
                      getMainDistrictList()
                      registerForm.mainDistrict = ''
                    }"
                    :disabled="locked">
                    <el-option label="--- Sila Pilih ---" value=""></el-option>
                    <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" prop="mainDistrict" required>
                  <el-select
                    ref="mainDistrict"
                    class="el-input-size"
                    v-model="registerForm.mainDistrict"
                    :disabled="locked">
                    <el-option label="--- Sila Pilih ---" value=""></el-option>
                    <el-option v-for="(district, key) in currentMainDistrictList" :key="key" :label="district.label" :value="district.label"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="checkboxContainer">
                <el-checkbox v-model="postagedifferent" label="(sila tandakan dan masukkan alamat surat-menyurat sekiranya berbeza daripada alamat operasi)" style="font-size: 1em; margin-top: 10px; text-align: left;" :disabled="locked"/>
              </div>
              <el-form-item label="Alamat Surat Menyurat" required key="FormpostAddressParentA">
                <div v-if="postagedifferent === true">
                  <el-form-item prop="postAddress1" key="FormpostAddress1A">
                    <el-input
                      key="postAddress1A"
                      ref="postAddress1"
                      class="el-input-size"
                      style="margin-bottom: 5px;"
                      v-model="registerForm.postAddress1"
                      @input="()=>autoCapitalise('postAddress1')"
                      :disabled="locked">
                    </el-input>
                    <el-input
                      key="postAddress2A"
                      ref="postAddress2"
                      class="el-input-size"
                      v-model="registerForm.postAddress2"
                      @input="()=>autoCapitalise('postAddress2')"
                      :disabled="locked">
                    </el-input>
                  </el-form-item>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" prop="postTown" required key="FormpostTownA">
                      <el-input
                        key="postTownA"
                        ref="postTown"
                        class="el-input-size"
                        v-model="registerForm.postTown"
                        @input="()=>autoCapitalise('postTown')"
                        :disabled="locked">
                      </el-input>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" prop="postPostcode" required key="FormpostPostcodeA">
                      <el-input
                        key="postPostcodeA"
                        ref="postPostcode"
                        class="el-input-size"
                        v-model="registerForm.postPostcode"
                        @input="()=>autoPostcode('postPostcode')"
                        :disabled="locked">
                      </el-input>
                    </el-form-item>
                  </div>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" prop="postStateLabel" required key="FormpostStateLabelA">
                      <el-select
                        key="postStateLabelA"
                        ref="postStateLabel"
                        class="el-input-size"
                        v-model="registerForm.postStateLabel"
                        @change="()=>{
                          getPostDistrictList()
                          registerForm.postDistrict = ''
                        }"
                        :disabled="locked">
                        <el-option label="--- Sila Pilih ---" value=""></el-option>
                        <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" prop="postDistrict" required key="FormpostDistrictA">
                      <el-select
                        key="postDistrictA"
                        ref="postDistrict"
                        class="el-input-size"
                        v-model="registerForm.postDistrict"
                        @input="()=>autoCapitalise('postDistrict')"
                        :disabled="locked">
                          <el-option label="--- Sila Pilih ---" value=""></el-option>
                          <el-option v-for="(district, key) in currentPostDistrictList" :key="key" :label="district.label" :value="district.label"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div v-else>
                  <el-form-item key="FormpostAddressB">
                    <el-input
                      key="postAddress1B"
                      ref="postAddress1"
                      class="el-input-size"
                      v-model="registerForm.mainAddress1"
                      @input="()=>autoCapitalise('mainAddress1')"
                      disabled>
                    </el-input>
                    <el-input
                      key="postAddress2B"
                      ref="postAddress2"
                      class="el-input-size"
                      v-model="registerForm.mainAddress2"
                      @input="()=>autoCapitalise('mainAddress2')"
                      disabled>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" required key="FormpostStateLabelB">
                    <el-select
                      key="postStateLabelB"
                      ref="postStateLabel"
                      class="el-input-size"
                      v-model="registerForm.mainStateLabel"
                      disabled>
                      <el-option label="--- Sila Pilih ---" value=""></el-option>
                      <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" required key="FormpostDistrictB">
                    <el-input
                      key="postDistrictB"
                      ref="postDistrict"
                      class="el-input-size"
                      v-model="registerForm.mainDistrict"
                      @input="()=>autoCapitalise('mainDistrict')"
                      disabled>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" required key="FormpostTownB">
                    <el-input
                      key="postTownB"
                      ref="postTown"
                      class="el-input-size"
                      v-model="registerForm.mainTown"
                      @input="()=>autoCapitalise('mainTown')"
                      disabled>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" required key="FormpostPostcodeB">
                    <el-input
                      key="postPostcodeB"
                      ref="postPostcode"
                      class="el-input-size"
                      v-model="registerForm.mainPostcode"
                      @input="()=>autoPostcode('mainPostcode')"
                      disabled>
                    </el-input>
                  </el-form-item>
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- <el-form-item label="Daerah" required>
            <el-select
              ref="individualDistrict"
              class="el-input-size"
              v-model="registerForm.individualDistrict"
              @input="()=>autoCapitalise('individualDistrict')"
              :disabled="locked">
              <el-option label="--- Sila Pilih ---" value=""></el-option>
              <el-option
                v-for="district in districtList"
                :key="district"
                :label="district"
                :value="district">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <template slot="label">
              No. Telefon Pejabat
              <el-tooltip content="Sila isi no telefon pejabat tanpa '-', contoh 036213456" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="individualOfficeTelephone"
              class="el-input-size"
              v-model="registerForm.individualOfficeTelephone"
              @input="()=>autoTelephone('individualOfficeTelephone')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item required>
            <template slot="label">
              No. Telefon (H/P)
              <el-tooltip content="Sila isi no telefon bimbit tanpa '-', contoh 0123456789" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="individualTelephone"
              class="el-input-size"
              v-model="registerForm.individualTelephone"
              @input="()=>autoTelephone('individualTelephone')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              No. Fax
              <el-tooltip content="Sila isi no fax tanpa '-', contoh 036213457" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="individualOfficeFax"
              class="el-input-size"
              v-model="registerForm.individualOfficeFax"
              @input="()=>autoFax('individualOfficeFax')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item label="Emel" required>
            <el-input
              ref="email"
              class="el-input-size"
              v-model="registerForm.email"
              @input="()=>autoCapitalise('email')"
              disabled>
            </el-input>
          </el-form-item>
        </el-form>
        <el-form key="userData2" class="profileForm" :model="registerForm" :rules="companyRules" ref="userData2" style="width:100%;" v-loading="loading" v-else-if="registerForm.registrationType === 'company'">
          <el-form-item label="Kategori Permohonan" required>
            <el-input
              ref="registrationType"
              class="el-input-size"
              :value="registrationTypeLabel"
              @input="()=>autoCapitalise('registrationType')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Nama Syarikat" required>
            <el-input
              ref="companyName"
              class="el-input-size"
              v-model="registerForm.companyName"
              @input="()=>autoCapitalise('companyName')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. Pendaftaran Syarikat (lama)" required>
            <el-input
              ref="companySSMOld"
              class="el-input-size"
              v-model="registerForm.companySSMOld"
              @input="()=>autoCapitalise('companySSMOld')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. SSM Baru" required>
            <el-input
              ref="companySSMNew"
              class="el-input-size"
              v-model="registerForm.companySSMNew"
              @input="()=>autoCapitalise('companySSMNew')"
              disabled>
            </el-input>
          </el-form-item>
          <div class="card">
            <div class="cardContent">
              <el-form-item label="Alamat Operasi" prop="mainAddress1" required>
                <el-input
                  ref="mainAddress1"
                  class="el-input-size"
                  style="margin-bottom: 5px;"
                  v-model="registerForm.mainAddress1"
                  @input="()=>autoCapitalise('mainAddress1')"
                  :disabled="locked">
                </el-input>
                <el-input
                  ref="mainAddress2"
                  class="el-input-size"
                  v-model="registerForm.mainAddress2"
                  @input="()=>autoCapitalise('mainAddress2')"
                  :disabled="locked">
                </el-input>
              </el-form-item>
              <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" prop="mainTown" required>
                  <el-input
                    ref="mainTown"
                    class="el-input-size"
                    v-model="registerForm.mainTown"
                    @input="()=>autoCapitalise('mainTown')"
                    :disabled="locked">
                  </el-input>
                </el-form-item>
                <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" prop="mainPostcode" required>
                  <el-input
                    ref="mainPostcode"
                    class="el-input-size"
                    v-model="registerForm.mainPostcode"
                    @input="()=>autoPostcode('mainPostcode')"
                    :disabled="locked">
                  </el-input>
                </el-form-item>
              </div>
              <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" prop="mainStateLabel" required>
                  <el-select
                    ref="mainStateLabel"
                    class="el-input-size"
                    v-model="registerForm.mainStateLabel"
                    @change="()=>{
                      getMainDistrictList()
                      registerForm.mainDistrict = ''
                    }"
                    :disabled="locked">
                    <el-option label="--- Sila Pilih ---" value=""></el-option>
                    <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" prop="mainDistrict" required>
                  <el-select
                    ref="mainDistrict"
                    class="el-input-size"
                    v-model="registerForm.mainDistrict"
                    :disabled="locked">
                    <el-option label="--- Sila Pilih ---" value=""></el-option>
                    <el-option v-for="(district, key) in currentMainDistrictList" :key="key" :label="district.label" :value="district.label"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="checkboxContainer">
                <el-checkbox v-model="postagedifferent" label="(sila tandakan dan masukkan alamat surat-menyurat sekiranya berbeza daripada alamat operasi)" style="font-size: 1em; margin-top: 10px; text-align: left;" :disabled="locked"/>
              </div>
              <el-form-item label="Alamat Surat Menyurat" required key="FormpostAddressParentA">
                <div v-if="postagedifferent === true">
                  <el-form-item prop="postAddress1" key="FormpostAddress1A">
                    <el-input
                      key="postAddress1A"
                      ref="postAddress1"
                      class="el-input-size"
                      style="margin-bottom: 5px;"
                      v-model="registerForm.postAddress1"
                      @input="()=>autoCapitalise('postAddress1')"
                      :disabled="locked">
                    </el-input>
                    <el-input
                      key="postAddress2A"
                      ref="postAddress2"
                      class="el-input-size"
                      v-model="registerForm.postAddress2"
                      @input="()=>autoCapitalise('postAddress2')"
                      :disabled="locked">
                    </el-input>
                  </el-form-item>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" prop="postTown" required key="FormpostTownA">
                      <el-input
                        key="postTownA"
                        ref="postTown"
                        class="el-input-size"
                        v-model="registerForm.postTown"
                        @input="()=>autoCapitalise('postTown')"
                        :disabled="locked">
                      </el-input>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" prop="postPostcode" required key="FormpostPostcodeA">
                      <el-input
                        key="postPostcodeA"
                        ref="postPostcode"
                        class="el-input-size"
                        v-model="registerForm.postPostcode"
                        @input="()=>autoPostcode('postPostcode')"
                        :disabled="locked">
                      </el-input>
                    </el-form-item>
                  </div>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" prop="postStateLabel" required key="FormpostStateLabelA">
                      <el-select
                        key="postStateLabelA"
                        ref="postStateLabel"
                        class="el-input-size"
                        v-model="registerForm.postStateLabel"
                        @change="()=>{
                          getPostDistrictList()
                          registerForm.postDistrict = ''
                        }"
                        :disabled="locked">
                        <el-option label="--- Sila Pilih ---" value=""></el-option>
                        <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" prop="postDistrict" required key="FormpostDistrictA">
                      <el-select
                        key="postDistrictA"
                        ref="postDistrict"
                        class="el-input-size"
                        v-model="registerForm.postDistrict"
                        @input="()=>autoCapitalise('postDistrict')"
                        :disabled="locked">
                          <el-option label="--- Sila Pilih ---" value=""></el-option>
                          <el-option v-for="(district, key) in currentPostDistrictList" :key="key" :label="district.label" :value="district.label"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div v-else>
                  <el-form-item key="FormpostAddressB">
                    <el-input
                      key="postAddress1B"
                      ref="postAddress1"
                      class="el-input-size"
                      v-model="registerForm.mainAddress1"
                      @input="()=>autoCapitalise('mainAddress1')"
                      disabled>
                    </el-input>
                    <el-input
                      key="postAddress2B"
                      ref="postAddress2"
                      class="el-input-size"
                      v-model="registerForm.mainAddress2"
                      @input="()=>autoCapitalise('mainAddress2')"
                      disabled>
                    </el-input>
                  </el-form-item>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" required key="FormpostTownB">
                      <el-input
                        key="postTownB"
                        ref="postTown"
                        class="el-input-size"
                        v-model="registerForm.mainTown"
                        @input="()=>autoCapitalise('mainTown')"
                        disabled>
                      </el-input>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" required key="FormpostPostcodeB">
                      <el-input
                        key="postPostcodeB"
                        ref="postPostcode"
                        class="el-input-size"
                        v-model="registerForm.mainPostcode"
                        @input="()=>autoPostcode('mainPostcode')"
                        disabled>
                      </el-input>
                    </el-form-item>
                  </div>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" required key="FormpostStateLabelB">
                      <el-select
                        key="postStateLabelB"
                        ref="postStateLabel"
                        class="el-input-size"
                        v-model="registerForm.mainStateLabel"
                        disabled>
                        <el-option label="--- Sila Pilih ---" value=""></el-option>
                        <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" required key="FormpostDistrictB">
                      <el-input
                        key="postDistrictB"
                        ref="postDistrict"
                        class="el-input-size"
                        v-model="registerForm.mainDistrict"
                        @input="()=>autoCapitalise('mainDistrict')"
                        disabled>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- <el-form-item label="Daerah" required>
            <el-select
              ref="companyDistrict"
              class="el-input-size"
              v-model="registerForm.companyDistrict"
              @input="()=>autoCapitalise('companyDistrict')"
              :disabled="locked">
              <el-option label="--- Sila Pilih ---" value=""></el-option>
              <el-option
                v-for="district in districtList"
                :key="district"
                :label="district"
                :value="district">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <template slot="label">
              No. Telefon Pejabat
              <el-tooltip content="Sila isi no telefon pejabat tanpa '-', contoh 036213456" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="companyOfficeTelephone"
              class="el-input-size"
              v-model="registerForm.companyOfficeTelephone"
              @input="()=>autoTelephone('companyOfficeTelephone')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item prop="companyPICTelephone" required>
            <template slot="label">
              No. Telefon (H/P)
              <el-tooltip content="Sila isi no telefon bimbit tanpa '-', contoh 0123456789" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="companyPICTelephone"
              class="el-input-size"
              v-model="registerForm.companyPICTelephone"
              @input="()=>autoTelephone('companyPICTelephone')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              No. Fax
              <el-tooltip content="Sila isi no fax tanpa '-', contoh 036213457" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="companyOfficeFax"
              class="el-input-size"
              v-model="registerForm.companyOfficeFax"
              @input="()=>autoFax('companyOfficeFax')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item label="Emel" required>
            <el-input
              ref="email"
              class="el-input-size"
              v-model="registerForm.email"
              @input="()=>autoCapitalise('email')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Nama Wakil" prop="companyPICName" required>
            <el-input
              ref="companyPICName"
              class="el-input-size"
              v-model="registerForm.companyPICName"
              @input="()=>autoCapitalise('companyPICName')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item prop="companyPICIC" required>
            <template slot="label">
              No. Kad Pengenalan Wakil
              <el-tooltip content="Sila isi no kad pengenalan tanpa '-' dengan 12 digit" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="companyPICIC"
              class="el-input-size"
              v-model="registerForm.companyPICIC"
              @input="()=>autoIC('companyPICIC')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item label="Jawatan Wakil" prop="companyPICPosition" required>
            <el-input
              ref="companyPICPosition"
              class="el-input-size"
              v-model="registerForm.companyPICPosition"
              @input="()=>autoCapitalise('companyPICPosition')"
              :disabled="locked">
            </el-input>
          </el-form-item>
        </el-form>
        <el-form key="userData3" class="profileForm" :model="registerForm" :rules="corporationRules" ref="userData3" style="width:100%;" v-loading="loading" v-else>
          <el-form-item label="Kategori Permohonan" required>
            <el-input
              ref="registrationType"
              class="el-input-size"
              :value="registrationTypeLabel"
              @input="()=>autoCapitalise('registrationType')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Nama Koperasi" required>
            <el-input
              ref="corporationName"
              class="el-input-size"
              v-model="registerForm.corporationName"
              @input="()=>autoCapitalise('corporationName')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. SKM/PBT/Ordinan" required>
            <el-input
              ref="corporationPBT"
              class="el-input-size"
              v-model="registerForm.corporationPBT"
              @input="()=>autoCapitalise('corporationPBT')"
              disabled>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="No. SSM Baru" required>
            <el-input
              ref="companySSMNew"
              class="el-input-size"
              v-model="registerForm.companySSMNew"
              @input="()=>autoCapitalise('companySSMNew')"
              disabled>
            </el-input>
          </el-form-item> -->
          <div class="card">
            <div class="cardContent">
              <el-form-item label="Alamat Operasi" prop="mainAddress1" required>
                <el-input
                  ref="mainAddress1"
                  class="el-input-size"
                  style="margin-bottom: 5px;"
                  v-model="registerForm.mainAddress1"
                  @input="()=>autoCapitalise('mainAddress1')"
                  :disabled="locked">
                </el-input>
                <el-input
                  ref="mainAddress2"
                  class="el-input-size"
                  v-model="registerForm.mainAddress2"
                  @input="()=>autoCapitalise('mainAddress2')"
                  :disabled="locked">
                </el-input>
              </el-form-item>
              <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" prop="mainTown" required>
                  <el-input
                    ref="mainTown"
                    class="el-input-size"
                    v-model="registerForm.mainTown"
                    @input="()=>autoCapitalise('mainTown')"
                    :disabled="locked">
                  </el-input>
                </el-form-item>
                <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" prop="mainPostcode" required>
                  <el-input
                    ref="mainPostcode"
                    class="el-input-size"
                    v-model="registerForm.mainPostcode"
                    @input="()=>autoPostcode('mainPostcode')"
                    :disabled="locked">
                  </el-input>
                </el-form-item>
              </div>
              <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" prop="mainStateLabel" required>
                  <el-select
                    ref="mainStateLabel"
                    class="el-input-size"
                    v-model="registerForm.mainStateLabel"
                    @change="()=>{
                      getMainDistrictList()
                      registerForm.mainDistrict = ''
                    }"
                    :disabled="locked">
                    <el-option label="--- Sila Pilih ---" value=""></el-option>
                    <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" prop="mainDistrict" required>
                  <el-select
                    ref="mainDistrict"
                    class="el-input-size"
                    v-model="registerForm.mainDistrict"
                    :disabled="locked">
                    <el-option label="--- Sila Pilih ---" value=""></el-option>
                    <el-option v-for="(district, key) in currentMainDistrictList" :key="key" :label="district.label" :value="district.label"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="checkboxContainer">
                <el-checkbox v-model="postagedifferent" label="(sila tandakan dan masukkan alamat surat-menyurat sekiranya berbeza daripada alamat operasi)" style="font-size: 1em; margin-top: 10px; text-align: left;" :disabled="locked"/>
              </div>
              <el-form-item label="Alamat Surat Menyurat" required key="FormpostAddressParentA">
                <div v-if="postagedifferent === true">
                  <el-form-item prop="postAddress1" key="FormpostAddress1A">
                    <el-input
                      key="postAddress1A"
                      ref="postAddress1"
                      class="el-input-size"
                      style="margin-bottom: 5px;"
                      v-model="registerForm.postAddress1"
                      @input="()=>autoCapitalise('postAddress1')"
                      :disabled="locked">
                    </el-input>
                    <el-input
                      key="postAddress2A"
                      ref="postAddress2"
                      class="el-input-size"
                      v-model="registerForm.postAddress2"
                      @input="()=>autoCapitalise('postAddress2')"
                      :disabled="locked">
                    </el-input>
                  </el-form-item>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" prop="postTown" required key="FormpostTownA">
                      <el-input
                        key="postTownA"
                        ref="postTown"
                        class="el-input-size"
                        v-model="registerForm.postTown"
                        @input="()=>autoCapitalise('postTown')"
                        :disabled="locked">
                      </el-input>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" prop="postPostcode" required key="FormpostPostcodeA">
                      <el-input
                        key="postPostcodeA"
                        ref="postPostcode"
                        class="el-input-size"
                        v-model="registerForm.postPostcode"
                        @input="()=>autoPostcode('postPostcode')"
                        :disabled="locked">
                      </el-input>
                    </el-form-item>
                  </div>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" prop="postStateLabel" required key="FormpostStateLabelA">
                      <el-select
                        key="postStateLabelA"
                        ref="postStateLabel"
                        class="el-input-size"
                        v-model="registerForm.postStateLabel"
                        @change="()=>{
                          getPostDistrictList()
                          registerForm.postDistrict = ''
                        }"
                        :disabled="locked">
                        <el-option label="--- Sila Pilih ---" value=""></el-option>
                        <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" prop="postDistrict" required key="FormpostDistrictA">
                      <el-select
                        key="postDistrictA"
                        ref="postDistrict"
                        class="el-input-size"
                        v-model="registerForm.postDistrict"
                        @input="()=>autoCapitalise('postDistrict')"
                        :disabled="locked">
                          <el-option label="--- Sila Pilih ---" value=""></el-option>
                          <el-option v-for="(district, key) in currentPostDistrictList" :key="key" :label="district.label" :value="district.label"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div v-else>
                  <el-form-item key="FormpostAddressB">
                    <el-input
                      key="postAddress1B"
                      ref="postAddress1"
                      class="el-input-size"
                      v-model="registerForm.mainAddress1"
                      @input="()=>autoCapitalise('mainAddress1')"
                      disabled>
                    </el-input>
                    <el-input
                      key="postAddress2B"
                      ref="postAddress2"
                      class="el-input-size"
                      v-model="registerForm.mainAddress2"
                      @input="()=>autoCapitalise('mainAddress2')"
                      disabled>
                    </el-input>
                  </el-form-item>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 70%; min-width: 300px;" label="Bandar" required key="FormpostTownB">
                      <el-input
                        key="postTownB"
                        ref="postTown"
                        class="el-input-size"
                        v-model="registerForm.mainTown"
                        @input="()=>autoCapitalise('mainTown')"
                        disabled>
                      </el-input>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; max-width: 30%; min-width: 150px;" label="Poskod" required key="FormpostPostcodeB">
                      <el-input
                        key="postPostcodeB"
                        ref="postPostcode"
                        class="el-input-size"
                        v-model="registerForm.mainPostcode"
                        @input="()=>autoPostcode('mainPostcode')"
                        disabled>
                      </el-input>
                    </el-form-item>
                  </div>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Negeri" required key="FormpostStateLabelB">
                      <el-select
                        key="postStateLabelB"
                        ref="postStateLabel"
                        class="el-input-size"
                        v-model="registerForm.mainStateLabel"
                        disabled>
                        <el-option label="--- Sila Pilih ---" value=""></el-option>
                        <el-option v-for="(state, key) in stateList" :key="key" :label="state.label" :value="state.label"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="mobilemaxw" style="flex: 1; min-width: 300px;" label="Daerah" required key="FormpostDistrictB">
                      <el-input
                        key="postDistrictB"
                        ref="postDistrict"
                        class="el-input-size"
                        v-model="registerForm.mainDistrict"
                        @input="()=>autoCapitalise('mainDistrict')"
                        disabled>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- <el-form-item label="Daerah" required>
            <el-select
              ref="companyDistrict"
              class="el-input-size"
              v-model="registerForm.companyDistrict"
              @input="()=>autoCapitalise('companyDistrict')"
              :disabled="locked">
              <el-option label="--- Sila Pilih ---" value=""></el-option>
              <el-option</el-form-item>
                v-for="district in districtList"
                :key="district"
                :label="district"
                :value="district">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <template slot="label">
              No. Telefon Pejabat
              <el-tooltip content="Sila isi no telefon pejabat tanpa '-', contoh 036213456" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="corporationOfficeTelephone"
              class="el-input-size"
              v-model="registerForm.corporationOfficeTelephone"
              @input="()=>autoTelephone('corporationOfficeTelephone')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item prop="corporationPICTelephone" required>
            <template slot="label">
              No. Telefon (H/P)
              <el-tooltip content="Sila isi no telefon bimbit tanpa '-', contoh 0123456789" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="corporationPICTelephone"
              class="el-input-size"
              v-model="registerForm.corporationPICTelephone"
              @input="()=>autoTelephone('corporationPICTelephone')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              No. Fax
              <el-tooltip content="Sila isi no fax tanpa '-', contoh 036213457" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="corporationOfficeFax"
              class="el-input-size"
              v-model="registerForm.corporationOfficeFax"
              @input="()=>autoFax('corporationOfficeFax')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item label="Emel" required>
            <el-input
              ref="email"
              class="el-input-size"
              v-model="registerForm.email"
              @input="()=>autoCapitalise('email')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Nama Wakil" prop="corporationPICName" required>
            <el-input
              ref="corporationPICName"
              class="el-input-size"
              v-model="registerForm.corporationPICName"
              @input="()=>autoCapitalise('corporationPICName')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item prop="corporationPICIC" required>
            <template slot="label">
              No. Kad Pengenalan Wakil
              <el-tooltip content="Sila isi no kad pengenalan tanpa '-' dengan 12 digit" placement="top">
                <i style="color: #666;" class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <el-input
              ref="corporationPICIC"
              class="el-input-size"
              v-model="registerForm.corporationPICIC"
              @input="()=>autoIC('corporationPICIC')"
              :disabled="locked">
            </el-input>
          </el-form-item>
          <el-form-item label="Jawatan Wakil" prop="corporationPICPosition" required>
            <el-input
              ref="corporationPICPosition"
              class="el-input-size"
              v-model="registerForm.corporationPICPosition"
              @input="()=>autoCapitalise('corporationPICPosition')"
              :disabled="locked">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import districts from '@/json/districts.json'
import moment from 'moment'

export default {
  name: 'profile',
  data() {
    const validatePostAddress1 = (rule, value, callback) => {
      if (this.postagedifferent === false) {
        callback();
      } else {
        if (value === '') {
          callback(new Error('Sila isikan alamat surat-menyurat anda'));
        } else {
          callback();
        }
      }
    };

    const validatePostPostcode = (rule, value, callback) => {
      if (this.postagedifferent === false) {
        callback();
      } else {
        if (value === '') {
          callback(new Error('Sila isikan poskod surat-menyurat anda'));
        } else {
          callback();
        }
      }
    };

    const validatePostTown = (rule, value, callback) => {
      if (this.postagedifferent === false) {
        callback();
      } else {
        if (value === '') {
          callback(new Error('Sila isikan bandar surat-menyurat anda'));
        } else {
          callback();
        }
      }
    };

    const validatePostStateLabel = (rule, value, callback) => {
      if (this.postagedifferent === false) {
        callback();
      } else {
        if (value === '') {
          callback(new Error('Sila isikan negeri surat-menyurat anda'));
        } else {
          callback();
        }
      }
    };

    const validatePostDistrict = (rule, value, callback) => {
      if (this.postagedifferent === false) {
        callback();
      } else {
        if (value === '') {
          callback(new Error('Sila isikan daerah surat-menyurat anda'));
        } else {
          callback();
        }
      }
    };

    const validateIC = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Sila isikan nombor kad pengenalan anda'));
      } else {
        if (value.length === 12) {
          callback();
        } else {
          callback(new Error('Sila semak nombor kad pengenalan anda'));
        }
      }
    };

    return {
      loading: false,
      btnloading: true,
      serviceName: process.env.SERVICE_NAME,
      individualRules: {
        mainAddress1: [{ required: true, message: 'Sila isikan alamat operasi anda' }],
        mainPostcode: [{ required: true, message: 'Sila isikan poskod operasi anda' }],
        mainTown: [{ required: true, message: 'Sila isikan bandar operasi anda' }],
        mainStateLabel: [{ required: true, message: 'Sila isikan negeri operasi anda' }],
        mainDistrict: [{ required: true, message: 'Sila isikan daerah operasi anda' }],
        postAddress1: [{ required: true, validator: validatePostAddress1 }],
        postPostcode: [{ required: true, validator: validatePostPostcode }],
        postTown: [{ required: true, validator: validatePostTown }],
        postStateLabel: [{ required: true, validator: validatePostStateLabel }],
        postDistrict: [{ required: true, validator: validatePostDistrict }],
        individualTelephone: [{ required: true, message: 'Sila isikan no. telefon anda' }],
        individualName: [{ required: true, message: 'Sila isikan nama anda' }],
        individualIC: [{ required: true, validator: validateIC }],
      },
      companyRules: {
        mainAddress1: [{ required: true, message: 'Sila isikan alamat operasi anda' }],
        mainPostcode: [{ required: true, message: 'Sila isikan poskod operasi anda' }],
        mainTown: [{ required: true, message: 'Sila isikan bandar operasi anda' }],
        mainStateLabel: [{ required: true, message: 'Sila isikan negeri operasi anda' }],
        mainDistrict: [{ required: true, message: 'Sila isikan daerah operasi anda' }],
        postAddress1: [{ required: true, validator: validatePostAddress1 }],
        postPostcode: [{ required: true, validator: validatePostPostcode }],
        postTown: [{ required: true, validator: validatePostTown }],
        postStateLabel: [{ required: true, validator: validatePostStateLabel }],
        postDistrict: [{ required: true, validator: validatePostDistrict }],
        companyName: [{ required: true, message: 'Sila isikan nama syarikat anda' }],
        companySSMOld: [{ required: true, message: 'Sila isikan no. pendaftaran syarikat lama anda' }],
        companySSMNew: [{ required: true, message: 'Sila isikan no. pendaftaran syarikat baru anda' }],
        companyPICName: [{ required: true, message: 'Sila isikan nama wakil anda' }],
        companyPICIC: [{ required: true, validator: validateIC }],
        companyPICPosition: [{ required: true, message: 'Sila isikan jawatan wakil anda' }],
      },
      corporationRules: {
        mainAddress1: [{ required: true, message: 'Sila isikan alamat operasi anda' }],
        mainPostcode: [{ required: true, message: 'Sila isikan poskod operasi anda' }],
        mainTown: [{ required: true, message: 'Sila isikan bandar operasi anda' }],
        mainStateLabel: [{ required: true, message: 'Sila isikan negeri operasi anda' }],
        mainDistrict: [{ required: true, message: 'Sila isikan daerah operasi anda' }],
        postAddress1: [{ required: true, validator: validatePostAddress1 }],
        postPostcode: [{ required: true, validator: validatePostPostcode }],
        postTown: [{ required: true, validator: validatePostTown }],
        postStateLabel: [{ required: true, validator: validatePostStateLabel }],
        postDistrict: [{ required: true, validator: validatePostDistrict }],
        corporationName: [{ required: true, message: 'Sila isikan nama koperasi anda' }],
        corporationPBT: [{ required: true, message: 'Sila isikan no. SKM/PBT/Ordinan koperasi anda' }],
        corporationPICName: [{ required: true, message: 'Sila isikan nama wakil anda' }],
        corporationPICIC: [{ required: true, validator: validateIC }],
        corporationPICPosition: [{ required: true, message: 'Sila isikan jawatan wakil anda' }],
      },
      districts: districts,
      currentMainDistrictList: [],
      currentPostDistrictList: [],
      stateList: [
        {
          label: "JOHOR",
          value: "johor"
        },
        {
          label: "KEDAH",
          value: "kedah"
        },
        {
          label: "KELANTAN",
          value: "kelantan"
        },
        {
          label: "MELAKA",
          value: "melaka"
        },
        {
          label: "NEGERI SEMBILAN",
          value: "negeri sembilan"
        },
        {
          label: "PAHANG",
          value: "pahang"
        },
        {
          label: "PULAU PINANG",
          value: "pulau pinang"
        },
        {
          label: "PERAK",
          value: "perak"
        },
        {
          label: "PERLIS",
          value: "perlis"
        },
        {
          label: "SABAH",
          value: "sabah"
        },
        {
          label: "SARAWAK",
          value: "sarawak"
        },
        {
          label: "SELANGOR",
          value: "selangor"
        },
        {
          label: "TERENGGANU",
          value: "terengganu"
        },
        {
          label: "WILAYAH PERSEKUTUAN KUALA LUMPUR",
          value: "wilayah persekutuan kuala lumpur"
        },
        {
          label: "WILAYAH PERSEKUTUAN LABUAN",
          value: "wilayah persekutuan labuan"
        },
        {
          label: "WILAYAH PERSEKUTUAN PUTRAJAYA",
          value: "wilayah persekutuan putrajaya"
        },
      ],
      postagedifferent: false,
    }
  },
  methods: {
    getMainDistrictList() {
      this.currentMainDistrictList = this.districts[this.registerForm.mainStateLabel]
    },
    getPostDistrictList() {
      this.currentPostDistrictList = this.districts[this.registerForm.postStateLabel]
    },
    handleCurrencyInput(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      const value = this.registerForm[field].replace(/[^\d.-]/g, '')
      const dotPosition = value.indexOf('.')
      if (dotPosition !== -1) {
        const firsthalf = value.substring(0, dotPosition)
        const secondhalf = value.substring(dotPosition)
        this.registerForm[field] = Number(firsthalf).toLocaleString('en') + secondhalf
      } else {
        this.registerForm[field] = Number(value).toLocaleString('en')
      }
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    autoCapitalise(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.registerForm[field] = this.registerForm[field].toUpperCase()
      this.registerFormChanged = true
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    autoNumber(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.registerForm[field] = this.registerForm[field].replace(/[^\d]/g, '')
      this.registerFormChanged = true
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    autoPostcode(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.registerForm[field] = this.registerForm[field].replace(/[^\d]/g, '')
      if (this.registerForm[field].length > 5) {
        this.registerForm[field] = this.registerForm[field].substring(0, 5);
      }
      this.registerFormChanged = true
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    autoIC(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.registerForm[field] = this.registerForm[field].replace(/[^\d]/g, '')
      if (this.registerForm[field].length > 12) {
        this.registerForm[field] = this.registerForm[field].substring(0, 12);
      }
      this.registerFormChanged = true
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    autoTelephone(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.registerForm[field] = this.registerForm[field].replace(/[^\d- ]/g, '')
      if (this.registerForm[field].length > 12) {
        this.registerForm[field] = this.registerForm[field].substring(0, 12);
      }
      this.registerFormChanged = true
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    autoFax(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.registerForm[field] = this.registerForm[field].replace(/[^\d- ]/g, '')
      if (this.registerForm[field].length > 11) {
        this.registerForm[field] = this.registerForm[field].substring(0, 11);
      }
      this.registerFormChanged = true
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    autoLowercase(field) {
      const input = this.$refs[field].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.registerForm[field] = this.registerForm[field].toLowerCase()
      this.registerFormChanged = true
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    async navigateToWebPage(webpage) {
      this.$router.push(`/z/${this.$store.state.app.branchSelected}/mydiesel/${webpage}`)
    },
  },
  filters: {
    formatDateTime(val) {
      if (val !== undefined) {
        return moment.unix(Number(val)).format('DD/MM/YYYY HH:mm')
      }
      return ''
    }
  },
  watch: {
    registerForm: {
      handler: function (val) {
        this.$emit('handleFormChange', val)
      },
      deep: true
    },
  },
  computed: {
    awakRole() {
      return this.$store.state.user.awakRole
    },
    registrationTypeLabel() {
      switch (this.registerForm.registrationType) {
        case 'company': {
          return 'SYARIKAT'
        }
        case 'individual': {
          return 'INDIVIDU'
        }
        case 'corporation': {
          return 'KOPERASI'
        }
      }
    }
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    registerForm: {
      type: Object
    },
    handleFormChange: {
      type: Function
    },
    locked: {
      type: Boolean
    }
  },
  mounted() {
    console.log('mounted', this.registerForm.postAddressSameAsMainAddress)
    this.postagedifferent = !this.registerForm.postAddressSameAsMainAddress
  }
}
</script>

<style lang="scss">
.profilContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  margin-top: 0px;
}

</style>


// WEBPACK FOOTER //
// src/views/mydiesel/components/ProfilNewDiesel.vue